import { createFileRoute } from "@tanstack/react-router"
import { SocialMatchWelcomePage } from "@/pages/social-match"

export const Route = createFileRoute("/_authenticated/social-match/")({
	component: SocialMatchWelcomePage,
})
